<template>
  <div v-if="content">
    <slot>
      <rhombus-icon title="" class="indicator" :size="13" :fillColor="fillColor" />
    </slot>
    <span>{{titleCase(content)}}</span>
  </div>
  <div v-else>-</div>
</template>


<script>
  import {
    RhombusIcon,
  } from '../../icons.js';
  
  export default {
    name: 'AsStatus',
    props: {
      
      props: {
        type: [Array, Object],
        required: true,
      },
      
      fillColor: {
        type: String,
        default: '#333'
      }
    },
    computed: {
      
      content () {
        let { row, column } = this.props;
        return row && column ? row[column] : '';
      }
    },
    methods: {
      titleCase (str) {
        return str.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
      },
    },
    
    data () {
      return {};
    },
    
    components: {
      RhombusIcon
    }
  };
</script>
